<template>
  <View direction="column" gap="lg">
    <View direction="column" gap="xs">
      <Text variant="h2">Preferences</Text>
      <Text variant="body-large" color="secondary">How Tallo works on your behalf</Text>
    </View>

    <View direction="column" gap="md">
      <View direction="column" gap="xs">
        <Text variant="h5">Screening sensitivity</Text>
        <Text variant="body-medium" color="secondary">
          The default strictness for new inquiries — properties with their own screening setting keep it
        </Text>
      </View>

      <ScreeningSensitivityCards v-model="form.fields.preferredScreeningSensitivity" />
    </View>

    <Divider />

    <View justify="end">
      <Button :loading="form.submitting" @click="saveChanges">Save changes</Button>
    </View>
  </View>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { Button, Divider, extractErrorMessage, Text, useAlertsStore, useForm, View } from '@tallo/design-system';
import { useInvestorStore } from '@tallo/investor/investor';
import { ScreeningSensitivity, ScreeningSensitivityCards } from '@tallo/property';

import { useSeededForm } from '../composables/use-seeded-form';

const investorStore = useInvestorStore();
const alertsStore = useAlertsStore();
const { investor } = storeToRefs(investorStore);

const form = useForm({ preferredScreeningSensitivity: null as ScreeningSensitivity | null });

const isDirty = computed(
  () => form.fields.preferredScreeningSensitivity !== (investor.value?.preferredScreeningSensitivity ?? null),
);

useSeededForm(investor, reset, isDirty);

function reset() {
  form.fields.preferredScreeningSensitivity = investor.value?.preferredScreeningSensitivity ?? null;
}

function saveChanges() {
  if (!form.fields.preferredScreeningSensitivity) return;

  form.submit(async () => {
    try {
      await investorStore.updatePreferences({
        preferredScreeningSensitivity: form.fields.preferredScreeningSensitivity!,
      });
      alertsStore.success('Changes saved');
    } catch (error) {
      alertsStore.error(extractErrorMessage(error, 'Failed to save changes'));
    }
  });
}

defineExpose({ isDirty, reset });
</script>
